module.exports = __webpack_public_path__ + "static/img/bg.d3ff3640.png";